
<template>
  <div>
    <dialog-create-template></dialog-create-template>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import DialogCreateTemplate from '../../components/templates/DialogCreateTemplate.vue'
//import validations from '@/mixins/validations'
//import Api from '@/api/index';

export default {
  name: 'NewTemplatePage',
  //mixins: [ validations ],
  components: {
    DialogCreateTemplate
    //ComponentName: () => import(''),
  },
  data() {
    return {
      dialog: true,
    }
  },
  methods: {
    name() {
      
    },
    ...mapActions({
      // function: 'Module/action'
      //addNotification: 'Notification/add'
    })
  },
  computed: {
    ...mapState({
      // data: state=> state.Module.state_var
    })
  },
}
</script>

<style scoped>

</style>